import axios from "axios";
// import Swal from "sweetalert2";
// import router from "@/router";

const baseURL = process.env.VUE_APP_BASE_URL;
const username = process.env.VUE_APP_USERNAME;
const password = process.env.VUE_APP_PASSWORD;
const account = btoa(`${username}:${password}`);

axios.interceptors.request.use((config) => {
  config.baseURL = baseURL;

  config.headers.Authorization = `Basic ${account}`;

  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const { status, data } = error.response || {};
    console.error("HTTP Error:", status, data);

    // Swal.fire({
    //   toast: true,
    //   position: "bottom",
    //   icon: "error",
    //   title: data?.message || "Terjadi kesalahan",
    //   showConfirmButton: false,
    //   timer: 5000,
    //   timerProgressBar: true,
    // });

    return Promise.reject(error);
  },
);
